
import moment from 'moment'
import Config from '@/config'
import { API } from '@/models/core'
import { FootballMatch } from '@/models/match'
import { CricketMatch } from '@/models/cricket/match'
import { KabaddiSeason } from '@/models/kabaddi/season'

export class ScheduleDay {
  constructor (day, cricketMatches, footballMatches, kabaddiMatches) {
    this.day = day
    this.cricket = cricketMatches
    this.football = footballMatches
    this.kabaddi = kabaddiMatches
  }

  get matchesCount () {
    let count = 0
    count += this.cricket.length
    count += this.football.length
    count += this.kabaddi.length
    return count
  }

  get allMatches () {
    const matches = this.cricket.concat(this.football).concat(this.kabaddi)
    matches.sort((x, y) => {
      if (x.slotTime.isAfter(y.slotTime)) {
        return 1
      }
      return -1
    })

    return matches
  }
}

export class Schedule {
  constructor (month) {
    this.month = month
    this.days = []
    const lastDay = this.month.clone().endOf('month').date()
    for (let i = 0; i < lastDay; i++) {
      const day = new ScheduleDay(this.month.clone().add(i, 'days'), [], [], [])
      this.days.push(day)
    }
  }

  sortMatches () {
    this.days.forEach((day) => {
      day.football.sort((x, y) => {
        if (x.info.start_at.isAfter(y.info.start_at)) {
          return 1
        }
        return -1
      })
    })
  }

  static addToScheduleSlot (month, schedule, rawMatch) {
    const match = CricketMatch.createFromJson(rawMatch)
    const completeDate = match.possibleCompleteDate
    const days = match.dayDiff(completeDate)
    let slots = [match.start_at]

    for (let i = 0; i < days; i++) {
      const sloteDate = match.start_at.clone().add(i + 1, 'days')
      if (!match.format.isTest) {
        sloteDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      }
      slots.push(sloteDate)
    }

    slots.forEach((slot, i) => {
      if (month.isSame(slot, 'month')) {
        const newMatch = CricketMatch.createFromJson(rawMatch)
        newMatch.slotTime = slot
        newMatch.day = i + 1
        schedule.days[slot.date() - 1].cricket.push(newMatch)
      }
    })
  }

  static createFromJson (raw, kabaddiSchedule, forMonthKey = null) {
    let monthStr = forMonthKey

    if (!monthStr && raw.football) {
      monthStr = raw.football.current_month
    } else if (!monthStr && raw.cricket) {
      monthStr = raw.cricket.current_month
    }

    const month = moment(monthStr + '-01', 'YYYY-MM-DD')
    let schedule = new Schedule(month)
    if (raw.football) {
      raw.football.months[0].days.forEach(day => {
        day.matches.forEach(rawMatch => {
          const match = FootballMatch.createFromJson(rawMatch)
          if (month.isSame(match.info.start_at, 'month')) {
            schedule.days[match.info.start_at.date() - 1].football.push(match)
          }
        })
      })
    } else {
      raw.football = []
    }

    raw.cricket.months[0].days.forEach(day => {
      day.matches.forEach(rawMatch => {
        Schedule.addToScheduleSlot(month, schedule, rawMatch)
      })
    })

    if (raw.cricket_prev_5days) {
      raw.cricket_prev_5days.months[0].days.forEach(day => {
        day.matches.forEach(rawMatch => {
          Schedule.addToScheduleSlot(month, schedule, rawMatch)
        })
      })
    }

    if (kabaddiSchedule) {
      kabaddiSchedule.days.forEach((day) => {
        schedule.days[day.day.date() - 1].kabaddi = day.matches
      })
    }

    schedule.sortMatches()

    return schedule
  }

  static month (monthkey) {
    let reqMonth = null
    let url = '/schedule/'
    if (monthkey) {
      url = `/schedule/${monthkey}/`
      reqMonth = moment(monthkey + '-01', 'YYYY-MM-DD')
    }
    return API.instance().get(url).then(resp => {
      if (Config.kabaddiSeasonKey) {
        return KabaddiSeason.fetchSchedule(Config.kabaddiSeasonKey).then(months => {
          let kabaddiSchedule = null
          months.forEach((schedule) => {
            if (reqMonth === null && schedule.isCurrentMonth) {
              kabaddiSchedule = schedule
            } else if (reqMonth !== null && reqMonth.isSame(schedule.month, 'month')) {
              kabaddiSchedule = schedule
            }
          })
          return Schedule.createFromJson(resp.data.data, kabaddiSchedule)
        })
      }
      return Schedule.createFromJson(resp.data.data, null)
    })
  }

  static cricketMonth (monthkey) {
    let reqMonth = null
    let url = '/schedule/'
    if (monthkey) {
      url = `/schedule/${monthkey}/`
      reqMonth = moment(monthkey + '-01', 'YYYY-MM-DD')
    }
    return API.instance().get(url).then(resp => {
      delete resp.data.data.football
      return Schedule.createFromJson(resp.data.data, null)
    })
  }
}
